import React from "react";
import { styled } from "@mui/material";
import SelectedMessageDetails from "../SwiftDay/SelectedMessage/SelectedMessageDetails";

const Wrapper = styled("div")(() => ({
  display: "flex",
}));

const PrintingScreen = React.forwardRef((props, ref) => {
  const { rows } = props;

  const messagesDetails = rows.map((row) => row.messageDetails);

  return (
    <Wrapper style={{ height: "100vh" }} ref={ref}>
      <div style={{ flexGrow: 1 }}>
        {messagesDetails?.map((message, index) => {
          const details = message.details
            .filter(
              (item, idx, other) =>
                other.findIndex((itemV2) => itemV2.title === item.title) === idx
            )
            .sort((a, b) => a.title.localeCompare(b.title));

          const messageDetails = [
            {
              title: message.header.title,
              fieldKey: "",
              data: [
                { key: "Category", value: message.header.category },
                { key: "Type", value: message.header.messageType },
                { key: "Way", value: message.header.messageStatus },
              ],
            },
            ...details,
          ];

          return (
            <div key={message.header.uetr} className="message">
              <SelectedMessageDetails
                messageDetails={messageDetails}
                messageTreeDetails={message.treeDetails}
                isPrinting={true}
              />
              {index !== messagesDetails.length - 1 ? (
                <div className="page-break" />
              ) : null}
            </div>
          );
        })}
      </div>
    </Wrapper>
  );
});

export default PrintingScreen;
